module.exports = __webpack_public_path__ + "static/img/bg.2d12e36e.png";